import { Component, OnInit } from '@angular/core';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';

const height: string = '46px';
const iconAdd: string = 'icon-ic_add_circle_outline';
const iconRemove: string = 'icon-ic_remove_circle_outline';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent implements OnInit {
  public expandedHeight: string = height;
  public iconClassOpen: string = iconAdd;

  constructor() {}

  ngOnInit(): void {}

  public setClassIcon(accordionItem: MatExpansionPanel, icon: MatIcon) {
    let iconRef = icon._elementRef.nativeElement;
    if (accordionItem.expanded) {
      if (iconRef.classList.contains(iconAdd)) {
        iconRef.classList.remove(iconAdd);
      }
      iconRef.classList.add(iconRemove);
    } else {
      if (iconRef.classList.contains(iconRemove)) {
        iconRef.classList.remove(iconRemove);
      }
      iconRef.classList.add(iconAdd);
      console.log(iconRef.classList);
    }
  }
}
